module.exports = __webpack_public_path__ + "static/media/audience.5ec86ce6.svg";